// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1bxvB","errorLogs":"EditorFooter_errorLogs__gzQiF"};